import React, { useEffect, useState } from 'react';
import SignIn from './SignIn';
import Forget from './Forget';
import './index.scss';
import { Modal } from 'antd';

export default function LoginModal(props) {

  const [activeKey, setActiveKey] = useState(STATUS.SIGN);
  const { open, onCancel } = props;

  useEffect(() => {
    if(open) {
      setActiveKey(STATUS.SIGN);
    }
  }, [open]);

  return (
    <Modal
      className="ai_book-login"
      open={open}
      width={431}
      onCancel={onCancel}
      footer={null}
      centered
      destroyOnClose
    >
      {
        activeKey === STATUS.SIGN && <SignIn updateOperate={setActiveKey} />
      }
      {
        activeKey === STATUS.FORGET && <Forget updateOperate={setActiveKey} />
      }
    </Modal>
  );
}

const STATUS = {
  SIGN: 'SIGN',
  FORGET: 'FORGET'
};